import isMobile from './util/ismobile';

class VideoLoader {
    constructor(url, props){
        this.props = props;
        this.loaded = false;

        const video = document.createElement('video');
        video.src = url;

        let checkState = setInterval(() =>{
            if(video.readyState > (isMobile() ? 0 : 2)) {
                clearInterval(checkState);
                this.loaded = true;
                this.props._onSuccess('video', `success: ${url}`);
            }
        }, 100);

        video.onerror = () => this.props._onFail('video', `fail: ${url}`);

        setTimeout(() =>{
            !this.loaded && this.props._onFail('video', `fail: ${url}`);
        }, 5 * 1000)
    }
}

export default VideoLoader;